'use strict';

var $ = require('jquery');
var Countable = require('../../vendors/countable.js');
var Q = require('kew');
var ScrollMagic = require('scrollmagic');
var wNumb = require('../../vendors/wnumb.js');

var basePage = require('../pages/base-page.js');
var analytics = require('../utils/analytics.js');
var layout = require('../ui/layout.js');
var progressCircle = require('../components/progress-circle.js');
var scroll = require('../ui/scroll.js');

var slider = require('../components/slider.js');
var stringHelper = require('../utils/string-helper.js');
var submitApi = require('../api/submit-api.js');
var taxonomyApi = require('../api/taxonomy-api.js');
var TaxonomySelectorStore = require('../react/stores/taxonomy-selector-store.js');

var classNames = {
	ownerReviewForm: 'owner-review-form'
};

var formTextValues = {
	notBeforeRegYear: 'Purchase year cannot be before registration year.',
	requiredField: 'Please complete this field.',
	selectLabel: 'Please select',
	wordCount: 'Please enter at least {0} words.'
};

var ownerReviewCategory = 'Owner Review Submission';
var sentEvents = [];

var $form,
	$electricRangeQuestion,
	$mpgQuestion,
	$progressCircle,
	$reviewQuestions,
	$selectedVehicle,
	$selectVehiclePrompt,
	$taxonomySelector;

var derivativeDefer = null,
	isFormInitialised = false,
	progressStickyInstance = null,
	validatedElements = {
		carSelector: false,
		yearPlate: false,
		boughtNew: false,
		purchaseMonth: false,
		purchaseYear: false,
		mpgRange: false,
		mileage: false,
		reliability: false,
		expectation: false,
		wouldRecommend: false,
		vehicleRating: false,
		summary: false
	};

var $progressStickyContainer,
	$progressStickyTrigger,
	$progressStickyContainerHeight;


function setStickyProgressCircle() {
	if (progressStickyInstance) {
		progressStickyInstance.destroy(true);
	}

	progressStickyInstance = new ScrollMagic.Scene({
		triggerElement: $progressStickyTrigger[0],
		triggerHook: 0,								// attach trigger to top of screen
		offset: layout.getContentOffset(true) * -1, // offset distance from top of screen
		duration: $form.height() - $progressStickyContainerHeight
	})
	.setPin($progressStickyContainer[0])
	.addTo(scroll.getScrollMagicController());
}

function goToStep(stepNumber) {
	if (stepNumber === 1) {
		$selectedVehicle.hide();
		$taxonomySelector.show();
		$reviewQuestions.hide();
		$selectVehiclePrompt.show();
	} else if (stepNumber === 2) {
		$taxonomySelector.hide();
		$selectedVehicle.show();
		$selectVehiclePrompt.hide();
		$reviewQuestions.show();
	}
	setStickyProgressCircle();
}

function updateValidCount() {
	var validationFieldCount = Object.keys(validatedElements).length;
	var validatedCount = 0;
	for (var property in validatedElements) {
		if (validatedElements.hasOwnProperty(property)) {
			if(validatedElements[property] === true){
				validatedCount++;
			}
		}
	}

	var formPercentComplete = Math.ceil((validatedCount / validationFieldCount) * 100);
	$progressCircle.setProgress(formPercentComplete);
}

function sendOwnerReviewSubmissionEvent(question, action, label, nonInteractive) {
	if (!sentEvents[question]) {
		analytics.trackEvent(ownerReviewCategory, action, label, null, nonInteractive || false);
		sentEvents[question] = true;
	}
}

function sendTaxonomyOwnerReviewEvents() {
	var taxonomyState = TaxonomySelectorStore.getState();
	if (taxonomyState.selectedDerivative !== null) {
		sendOwnerReviewSubmissionEvent('derivative', '0D', 'Derivative Selected');
	}
	else if (taxonomyState.selectedModel !== null) {
		sendOwnerReviewSubmissionEvent('model', '0C', 'Model Selected');
	}
	else if (taxonomyState.selectedRange !== null) {
		sendOwnerReviewSubmissionEvent('range', '0B', 'Range Selected');
	}
	else if (taxonomyState.selectedManufacturer !== null) {
		sendOwnerReviewSubmissionEvent('manufacturer', '0A', 'Manufacturer Selected');
	}
}

function addEventHandlers() {
	$form.find('select[name="yearPlateId"]').on('change.ownerReviewForm', function () {
		validatedElements.yearPlate = (this.value !== '');
		updateValidCount();
	});

	$form.find('input[name="boughtNew"]').on('change.ownerReviewForm', function () {
		validatedElements.boughtNew = true;
		updateValidCount();
		sendOwnerReviewSubmissionEvent(this.name, '2', 'New Car Answered');
	});

	$form.find('select[name="purchaseMonth"]').on('change.ownerReviewForm', function () {
		validatedElements.purchaseMonth = (this.value !== '');
		updateValidCount();
		if (validatedElements.purchaseMonth && validatedElements.purchaseYear) {
			sendOwnerReviewSubmissionEvent('purchaseDate', '1', 'Year/Month Selected');
		}
	});

	$form.find('select[name="purchaseYear"]').on('change.ownerReviewForm', function () {
		validatedElements.purchaseYear = (this.value !== '');
		updateValidCount();
		if (validatedElements.purchaseMonth && validatedElements.purchaseYear) {
			sendOwnerReviewSubmissionEvent('purchaseDate', '1', 'Year/Month Selected');
		}
	});

	$form.find('input[name="reliabilityRating"]').on('change.ownerReviewForm', function () {
		validatedElements.reliability = true;
		updateValidCount();
		sendOwnerReviewSubmissionEvent(this.name, '5', 'Reliability Answered');
	});

	$form.find('textarea[name="reliabilityDetail"]').on('change.ownerReviewForm', function () {
		sendOwnerReviewSubmissionEvent(this.name, '5A', 'Reliability Text');
	});

	$form.find('input[name="expectationRating"]').on('change.ownerReviewForm', function () {
		validatedElements.expectation = true;
		updateValidCount();
		sendOwnerReviewSubmissionEvent(this.name, '6', 'Expectation Answered');
	});

	$form.find('textarea[name="expectationDetail"]').on('change.ownerReviewForm', function () {
		sendOwnerReviewSubmissionEvent(this.name, '6A', 'Expectation Text');
	});

	$form.find('input[name="wouldRecommend"]').on('change.ownerReviewForm', function () {
		validatedElements.wouldRecommend = true;
		updateValidCount();
		sendOwnerReviewSubmissionEvent(this.name, '7', 'Recommended Answered');
	});

	$form.find('input[name="rating"]').on('change.ownerReviewForm', function () {
		validatedElements.vehicleRating = true;
		updateValidCount();
		sendOwnerReviewSubmissionEvent(this.name, '8', 'Rated');
	});

	$form.find('textarea[name="summaryText"]').on('change.ownerReviewForm', function () {
		sendOwnerReviewSubmissionEvent(this.name, '9', 'Review Summary');
	});

	$form.find('input[name="reviewerName"]').on('change.ownerReviewForm', function () {
		sendOwnerReviewSubmissionEvent(this.name, '10', 'Full Name Entered');
	});

	$form.find('input[name="email"]').on('change.ownerReviewForm', function () {
		sendOwnerReviewSubmissionEvent(this.name, '11', 'Email Entered');
	});
}

function loadYearPlates(yearPlates) {
	var $yearPlateQuestion = $.findByBem(classNames.ownerReviewForm, 'question', 'year-plate');
	var $yearPlateSelect = $('#ddlYearPlate');
	var selectedYearPlate = $yearPlateSelect.val();

	$yearPlateSelect.empty();

	if (!yearPlates) {
		$yearPlateQuestion.attr('data-disabled', true).hide();
		validatedElements.yearPlate = true;
		return;
	}

	var index, yearPlate, yearPlateOptions = [], yearPlatesLength = yearPlates.length;
	yearPlateOptions.push('<option value="">' + formTextValues.selectLabel + '</option>');

	for (index = 0; index < yearPlatesLength; index++) {
		yearPlate = yearPlates[index];
		yearPlateOptions.push('<option value="' + yearPlate.id + '" data-year="' + yearPlate.year + '">' + yearPlate.displayName + '</option>');
	}

	$yearPlateSelect.append(yearPlateOptions).val(selectedYearPlate);
	$yearPlateQuestion.removeAttr('data-disabled').show();
}

function loadPurchaseYears(startYear, endYear) {
	var $purchaseYearSelect = $('#ddlPurchaseYear');
	var selectedYear = $purchaseYearSelect.val();

	var currentYear = endYear, yearOptions = [];
	yearOptions.push('<option value="">Year of purchase</option>');

	while (currentYear >= startYear) {
		yearOptions.push('<option value="' + currentYear + '">' + currentYear + '</option>');
		currentYear--;
	}

	$purchaseYearSelect.empty().append(yearOptions).val(selectedYear);
}

function initChangeVehicle() {
	$selectedVehicle.findByBem(classNames.ownerReviewForm, 'selected-vehicle__change-link').on('click.ownerReviewForm', function (e) {
		e.preventDefault();
		goToStep(1);
	});
}

function initComments() {
	$.findByBem(classNames.ownerReviewForm, 'comments__expand-link').on('click.ownerReviewForm', function (e) {
		e.preventDefault();
		$(this).hide().nextByBem(classNames.ownerReviewForm, 'comments__panel').slideDown('fast');
	});
}

function initMileageSlider() {
	var $mileageSlider = $.findByBem(classNames.ownerReviewForm, 'slider', 'vehicle-current-mileage');
	var $tbMileage = $('#tbMileage');

	if ($mileageSlider.length > 0 && $tbMileage.length > 0) {
		var mileageOptions = {
			placeholderText: [ formTextValues.selectLabel ],
			range: {
				min: 1000,
				max: 250000
			},
			start: 125000,
			step: 1000,
			tooltips: wNumb({
				decimals: 0,
				postfix: ' miles',
				thousand: ','
			})
		};
		slider.init($mileageSlider, mileageOptions, $tbMileage).on('set', function (value) {
			if (value > 0) {
				validatedElements.mileage = true;
				updateValidCount();
				$form.validate().element($tbMileage);
				sendOwnerReviewSubmissionEvent('mileage', '3', 'Mileage Answered');
			}
		});
	}
}

function initMpgSlider() {
	var $mpgSlider = $.findByBem(classNames.ownerReviewForm, 'slider', 'mpg');
	var $tbMpg = $('#tbMpg');

	if ($mpgSlider.length > 0 && $tbMpg.length > 0) {
		var mpgOptions = {
			placeholderText: [ formTextValues.selectLabel ] ,
			range: {
				min: 1,
				max: 100
			},
			start: 50,
			tooltips: wNumb({
				decimals: 0,
				postfix: ' mpg',
				thousand: ','
			})
		};
		slider.init($mpgSlider, mpgOptions, $tbMpg).on('set', function (value) {
			if (value > 0) {
				validatedElements.mpgRange = true;
				updateValidCount();
				$form.validate().element($tbMpg);
				sendOwnerReviewSubmissionEvent('mpg', '4', 'MPG Answered');
			}
		});
	}
}

function initElectricRangeSlider() {
	var $electricRangeSlider = $.findByBem(classNames.ownerReviewForm, 'slider', 'electric-range');
	var $tbElectricRange = $('#tbElectricRange');

	if ($electricRangeSlider.length > 0 && $tbElectricRange.length > 0) {
		var electricRangeOptions = {
			placeholderText: [ formTextValues.selectLabel ],
			range: {
				min: 1,
				max: 500
			},
			start: 100,
			tooltips: wNumb({
				decimals: 0,
				postfix: ' miles',
				thousand: ','
			})
		};
		slider.init($electricRangeSlider, electricRangeOptions, $tbElectricRange).on('set', function (value) {
			if (value > 0) {
				validatedElements.mpgRange = true;
				updateValidCount();
				$form.validate().element($tbElectricRange);
				sendOwnerReviewSubmissionEvent('electricRange', '4a', 'Electric Range Answered');
			}
		});
	}
}

function addCustomValidators() {
	$.validator.addMethod('notBeforeRegYear',
		function (value) {
			var $yearPlateSelect = $('#ddlYearPlate');
			if ($yearPlateSelect.length > 0 && $yearPlateSelect.val() !== '') {
				var regYear = $yearPlateSelect.children(':selected').attr('data-year') || 0;
				return value >= regYear;
			}
			return true;
		},
		$.validator.format(formTextValues.notBeforeRegYear)
	);

	$.validator.addMethod('wordCount',
		function (value, element, params) {
			var count = stringHelper.getWordCount(value);
			return count >= params[0];
		},
		$.validator.format(formTextValues.wordCount)
	);

	$.validator.messages.required = formTextValues.requiredField;
}

function submitForm() {
	var disabledClass = $.getBemClass(classNames.ownerReviewForm, 'submit-button', 'submitting');
	$.findByBem(classNames.ownerReviewForm, 'submit-button').disable(disabledClass);
	$.findByBem(classNames.ownerReviewForm, 'submit-error').hide();

	submitApi.submitOwnerReview($form.serialize(), {
		successCallback: function () {
			$(document).scrollTop(0);
			$(window).off('beforeunload.ownerReviewForm');
			$form.findByBem(classNames.ownerReviewForm, 'step').hide();
			$form.findByBem(classNames.ownerReviewForm, 'submit-success').show();
			analytics.trackPageview('/owner-reviews/submit/complete', 'Owner Review Submission Complete');

			sendOwnerReviewSubmissionEvent('success', '12', 'Review Successfully Submitted', true);
		},
		errorCallback: function () {
			$.findByBem(classNames.ownerReviewForm, 'submit-error').show();
		},
		completeCallback: function () {
			$.findByBem(classNames.ownerReviewForm, 'submit-button').enable(disabledClass);
		}
	});
}

function initValidation() {
	addCustomValidators();

	var $validationSummary = $.findByBem(classNames.ownerReviewForm, 'validation-summary').hide();

	$form.validate({
		rules: {
			boughtNew: { required: true },
			expectationRating: { required: true },
			rating: { required: true },
			purchaseYear: {
				required: true,
				notBeforeRegYear: true
			},
			reliabilityRating: { required: true },
			summaryText: {
				required: true,
				wordCount: ['50']
			},
			wouldRecommend: { required: true }
		},
		errorPlacement: function (error, $element) {
			if ($element.is(':radio')) {
				// multi-choice lists
				error.insertAfter($element.parents('ul'));
			} else if ($element.is('[type="number"]')) {
				// slider input field
				error.insertAfter($element.parent().parent());
			} else {
				error.insertAfter($element);
			}

			error.addClass('alert-box alert');
			error.addBemClass(classNames.ownerReviewForm, 'validation-error');
		},
		focusInvalid: false,
		invalidHandler: function () {
			$validationSummary.show();
		},
		submitHandler: function (form, event) {
			event.preventDefault();
			$validationSummary.hide();
			submitForm();
		}
	});
}

function initWordCount() {
	var $reviewSummary = $.findByBem(classNames.ownerReviewForm, 'input', 'summary');
	var $reviewSummaryWordCount = $.findByBem(classNames.ownerReviewForm , 'word-count__figure');

	Countable.on($reviewSummary[0], function (counter) {
		$reviewSummaryWordCount.text(counter.words);
		if(counter.words >= 50) {
			validatedElements.summary = true;
			updateValidCount();
		} else {
			validatedElements.summary = false;
			updateValidCount();
		}
	});
}

function initLeaveForm() {
	$(window).on('beforeunload.ownerReviewForm', function () {
		return 'If you leave this page now, you will lose the data you have entered.';
	});
}

function setSelectedVehicle(derivativeInfo) {
	$selectedVehicle.findByBem(classNames.ownerReviewForm, 'selected-vehicle__name').text(derivativeInfo.name);
}

function setQuestions(derivativeInfo) {
	if (derivativeInfo.isElectric) {
		$.findByBem(classNames.ownerReviewForm, 'question', 'mpg').attr('data-disabled', true).hide();
		$.findByBem(classNames.ownerReviewForm, 'question', 'electric-range').removeAttr('data-disabled').show();
	} else {
		$.findByBem(classNames.ownerReviewForm, 'question', 'mpg').removeAttr('data-disabled').show();
		$.findByBem(classNames.ownerReviewForm, 'question', 'electric-range').attr('data-disabled', true).hide();
	}

	loadYearPlates(derivativeInfo.yearPlates);
	loadPurchaseYears(derivativeInfo.firstPurchaseYear, derivativeInfo.lastPurchaseYear);

	var questionCount = 1;
	$.findByBem(classNames.ownerReviewForm, 'question').filter('[data-disabled!="true"]').each(function () {
		var questionNumber = $(this).findByBem(classNames.ownerReviewForm, 'question__number');
		if (questionNumber.length > 0) {
			questionNumber.text(questionCount + '.');
			questionCount++;
		}
	});
}

function initialiseForm(derivativeInfo) {
	if (!isFormInitialised) {
		initChangeVehicle();
		initMileageSlider();
		initMpgSlider();
		initElectricRangeSlider();
		initComments();
		initValidation();
		initWordCount();
		initLeaveForm();
		addEventHandlers();

		isFormInitialised = true;
	}

	setSelectedVehicle(derivativeInfo);
	setQuestions(derivativeInfo);

	goToStep(2);
}

function initProgressCircle() {
	if ($progressCircle.length > 0) {
		progressCircle.init($progressCircle);

		$progressStickyContainer = $form.findByBem(classNames.ownerReviewForm, 'progress__stickable');
		$progressStickyTrigger = $form.findByBem(classNames.ownerReviewForm, 'progress');
		$progressStickyContainerHeight = $progressStickyContainer.height();

		setStickyProgressCircle();
	}
}

function setControls() {
	$form = $.findByBem(classNames.ownerReviewForm);

	if ($form.length > 0) {
		$electricRangeQuestion = $form.findByBem(classNames.ownerReviewForm, 'question', 'electric-range');
		$mpgQuestion = $form.findByBem(classNames.ownerReviewForm, 'question', 'mpg');
		$progressCircle = $form.findByBem(classNames.ownerReviewForm, 'progress__meter');
		$reviewQuestions = $form.findByBem(classNames.ownerReviewForm, 'review-questions');
		$selectedVehicle = $form.findByBem(classNames.ownerReviewForm, 'selected-vehicle');
		$selectVehiclePrompt = $form.findByBem(classNames.ownerReviewForm, 'select-vehicle-prompt');
		$taxonomySelector = $form.findByBem(classNames.ownerReviewForm, 'taxonomy-selector');

		$form.findByBem(classNames.ownerReviewForm, 'step-button', 'step2').on('click.ownerReviewForm', function (e) {
			e.preventDefault();

			var $stepButton = $(this);
			var $stepError = $stepButton.siblingsByBem(classNames.ownerReviewForm, 'step-error', 'select-car');
			var $validationError = $stepButton.siblingsByBem(classNames.ownerReviewForm, 'validation-error', 'select-car');

			if (validatedElements.carSelector) {
				$stepError.hide();
				$validationError.hide();

				var disabledClass = $.getBemClass(classNames.ownerReviewForm, 'step-button', 'loading');
				$stepButton.disable(disabledClass);

				// wait for derivative info callback
				derivativeDefer.promise
					.then(function (derivativeInfo) {
						$stepButton.enable(disabledClass);
						initialiseForm(derivativeInfo);
					})
					.fail(function () {
						$stepError.show();
					});
			} else {
				$validationError.show();
			}
		});

		initProgressCircle();
	}
}

function getSelectedDerivativeId() {
	var taxonomyState = TaxonomySelectorStore.getState();

	if (taxonomyState.selectedDerivative !== null) {
		return parseInt(taxonomyState.selectedDerivative.key);
	}

	return null;
}

function taxonomySelectorChanged() {
	sendTaxonomyOwnerReviewEvents();
	var derivativeId = getSelectedDerivativeId();

	if (derivativeId !== null) {
		derivativeDefer = Q.defer();
		validatedElements.carSelector = true;
		updateValidCount();

		$.findByBem(classNames.ownerReviewForm, 'validation-error', 'select-car').hide();
		taxonomyApi.getDerivativeInfo('cars', derivativeId, {
			successCallback: function (data) {
				if (data && data.id === derivativeId) {
					derivativeDefer.resolve(data);
				}
			},
			errorCallback: function () {
				derivativeDefer.reject();
			}
		});
	} else {
		validatedElements.carSelector = false;
		updateValidCount();
	}
}
 
basePage.init = function() {
	basePage.initBasePage();

	setControls();

	if ($form.length > 0) {
		TaxonomySelectorStore.addChangeListener(taxonomySelectorChanged);
	}

	$(window).on('resize', function(){
		setStickyProgressCircle();
	});
	
};

module.exports = basePage;